var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VideoHeadline"},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.title))])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }